export const ORDER_POLICIESS_RESET_STATE = 'ORDER_POLICIESS_RESET_STATE';
export const ORDER_POLICIESS_CURRENT_ITEM = 'ORDER_POLICIESS_CURRENT_ITEM';

export const ORDER_POLICIESS_REQUEST_LOADING = 'ORDER_POLICIESS_REQUEST_LOADING';
export const ORDER_POLICIESS_REQUEST_SUCCESS = 'ORDER_POLICIESS_REQUEST_SUCCESS';
export const ORDER_POLICIESS_REQUEST_FAILED = 'ORDER_POLICIESS_REQUEST_FAILED';

export const ORDER_POLICIESS_CURRENT_ACTION = 'ORDER_POLICIESS_CURRENT_ACTION';
export const ORDER_POLICIESS_RESET_ACTION = 'ORDER_POLICIESS_RESET_ACTION';